module.exports = __webpack_public_path__ + "img/mastercard.6ccae62f.svg";